<template lang="html">
  <v-layout column class="event">
    <chat-user-header main-icon="message"
                      :event="event"
                      :participants="participants">commented</chat-user-header>
    <v-flex xs12 sm12 class="text-xs-left event-line ml-1 pl-4" align-center>
        <span class="font-weight-light message">{{event.message}}</span>
    </v-flex>
    <v-flex xs12 sm2 v-if="showTime" align-self-center
            class="text-sm-right text-sm-left event-line font-weight-light caption pr-2">
      <span>{{event.timestamp | formatDate}}</span>
    </v-flex>
  </v-layout>
</template>

<script>
import ChatUserHeader from './ChatUserHeader';

export default {
  name: 'UserCommentEvent',
  components: {
    ChatUserHeader,
  },
  props: {
    event: {
      required: true,
      type: Object,
    },
    participants: {
      required: true,
      type: Array,
    },
    showTime: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
};
</script>
<style lang="css" scoped>
  .event {
    border-left: 3px #428BCA solid;
  }

  span.message {
    white-space: pre-line;
  }
</style>



// WEBPACK FOOTER //
// src/components/timeline/UserCommentEvent.vue